import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/neanderthal_website/frontend/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/neanderthal_website/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/neanderthal_website/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/neanderthal_website/frontend/src/components/Navigation/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/neanderthal_website/frontend/src/components/Search/Search.tsx");
